module.exports = __webpack_public_path__ + "static/media/twitter.3d1b62ab.png";